export const dropdownOptions = [
  { value: "", label: "Select Title", disabled: true, hidden: true },
  { value: "engineering", label: "Engineering" },
  { value: "marketing", label: "Marketing" },
  { value: "sales", label: "Sales" },
  { value: "hr", label: "Human Resources" },
];

export const jobOpeningStatusOptions = [
  // { value: "", label: "Select Status", disabled: true, hidden: true },
  { value: "screening", label: "Screening" },
  { value: "submissions", label: "Submissions" },
  { value: "interview", label: "Interview" },
  { value: "offered", label: "Offered" },
  { value: "hired", label: "Hired" },
  { value: "rejected", label: "Rejected" },
  { value: "archived", label: "Archived" },
  { value: "closed", label: "Closed" },
  { value: "pending", label: "Pending" },
  { value: "on-hold", label: "On Hold" },
];

export const interviewStatusOptions = [
  { value: "scheduled", label: "Scheduled" },
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
  { value: "feedback_submitted", label: "Feedback Submitted" },
  { value: "cancelled", label: "Cancelled" },
  { value: "rescheduled", label: "Rescheduled" }
];

export const applicationStatusOptions = [
  { value: "submitted", label: "Submitted" },
  { value: "screening", label: "Screening" },
  { value: "shortlisted", label: "Shortlisted" },
  { value: "interview", label: "Interview" },
  { value: "interview_cleared", label: "Interview Cleared" },
  { value: "document_verification_in_progress", label: "Document Verification In Progress" },
  { value: "document_verification_completed", label: "Document Verification Completed" },
  { value: "loi_in_progress", label: "LOI In Progress" },
  { value: "loi_completed", label: "LOI Completed" },
  { value: "loi_rejected_by_candidate", label: "LOI Rejected by Candidate" },
  { value: "loi_expired", label: "LOI Expired" },
  { value: "offered", label: "Offered" },
  { value: "hired", label: "Hired" },
  { value: "rejected", label: "Rejected" },
  { value: "r1_rejected", label: "R1 Rejected" },
  { value: "r2_rejected", label: "R2 Rejected" },
  { value: "total_rejected", label: "Total Rejected" },
  { value: "final_rejected", label: "Final Rejected" },
  { value: "revoked", label: "Revoked" }
];

export const manualApplicationStatusOptions = applicationStatusOptions.filter(option =>
  ![
    "document_verification_in_progress",
    "document_verification_completed",
    "loi_in_progress",
    "loi_completed",
    "loi_rejected_by_candidate",
    "loi_expired"
  ].includes(option.value)
);

export const feedbackStatusOptions = [
  { value: "proceed", label: "Proceed" },
  { value: "consider", label: "Consider" },
  { value: "rejected", label: "Rejected" }
];

export const offerStatusOptions = [
  { value: "draft", label: "Draft" },
  { value: "pending_approval", label: "Pending Approval" },
  { value: "approved", label: "Approved" },
  { value: "sent", label: "Sent" },
  { value: "viewed", label: "Viewed" },
  { value: "accepted", label: "Accepted" },
  { value: "declined", label: "Declined" },
  { value: "expired", label: "Expired" },
  { value: "revoked", label: "Revoked" }
];

export const jobTypeOptions = [
  // { value: "", label: "Select Job Type", disabled: true, hidden: true },
  { value: "full_time", label: "Full-Time" },
  { value: "part_time", label: "Part-Time" },
  { value: "contract", label: "Contract" },
  { value: "internship", label: "Internship" },
  { value: "freelance", label: "Freelance" },
];

export const countryOptions = [
  { value: "", label: "Select Country", disabled: true, hidden: true },
  { value: "us", label: "United States" },
  { value: "ca", label: "Canada" },
  { value: "uk", label: "United Kingdom" },
  { value: "in", label: "India" },
  { value: "de", label: "Germany" },
  { value: "fr", label: "France" },
  { value: "au", label: "Australia" },
  { value: "jp", label: "Japan" },
  { value: "cn", label: "China" },
  { value: "br", label: "Brazil" },
];

export const requiredSkillsOptions = [
  // Programming Languages
  { value: "javascript", label: "JavaScript" },
  { value: "typescript", label: "TypeScript" },
  { value: "python", label: "Python" },
  { value: "java", label: "Java" },
  { value: "csharp", label: "C#" },
  { value: "php", label: "PHP" },
  { value: "ruby", label: "Ruby" },
  { value: "go", label: "Go" },
  { value: "rust", label: "Rust" },
  { value: "swift", label: "Swift" },
  { value: "kotlin", label: "Kotlin" },
  { value: "cpp", label: "C++" },
  { value: "c", label: "C" },

  // Frontend Technologies
  { value: "react", label: "React.js" },
  { value: "vue", label: "Vue.js" },
  { value: "angular", label: "Angular" },
  { value: "nextjs", label: "Next.js" },
  { value: "nuxtjs", label: "Nuxt.js" },
  { value: "svelte", label: "Svelte" },
  { value: "html", label: "HTML" },
  { value: "css", label: "CSS" },
  { value: "sass", label: "Sass/SCSS" },
  { value: "tailwind", label: "Tailwind CSS" },
  { value: "bootstrap", label: "Bootstrap" },
  { value: "jquery", label: "jQuery" },

  // Backend Technologies
  { value: "nodejs", label: "Node.js" },
  { value: "express", label: "Express.js" },
  { value: "nestjs", label: "NestJS" },
  { value: "django", label: "Django" },
  { value: "flask", label: "Flask" },
  { value: "fastapi", label: "FastAPI" },
  { value: "spring", label: "Spring Boot" },
  { value: "laravel", label: "Laravel" },
  { value: "rails", label: "Ruby on Rails" },
  { value: "dotnet", label: ".NET" },

  // Databases
  { value: "sql", label: "SQL" },
  { value: "mysql", label: "MySQL" },
  { value: "postgresql", label: "PostgreSQL" },
  { value: "mongodb", label: "MongoDB" },
  { value: "redis", label: "Redis" },
  { value: "sqlite", label: "SQLite" },
  { value: "oracle", label: "Oracle" },
  { value: "cassandra", label: "Cassandra" },
  { value: "elasticsearch", label: "Elasticsearch" },

  // Cloud Platforms
  { value: "aws", label: "AWS" },
  { value: "azure", label: "Microsoft Azure" },
  { value: "gcp", label: "Google Cloud Platform" },
  { value: "vercel", label: "Vercel" },
  { value: "netlify", label: "Netlify" },
  { value: "heroku", label: "Heroku" },
  { value: "digitalocean", label: "DigitalOcean" },

  // DevOps & Tools
  { value: "docker", label: "Docker" },
  { value: "kubernetes", label: "Kubernetes" },
  { value: "jenkins", label: "Jenkins" },
  { value: "gitlab-ci", label: "GitLab CI/CD" },
  { value: "github-actions", label: "GitHub Actions" },
  { value: "terraform", label: "Terraform" },
  { value: "ansible", label: "Ansible" },
  { value: "nginx", label: "Nginx" },
  { value: "apache", label: "Apache" },

  // Version Control & Collaboration
  { value: "git", label: "Git" },
  { value: "github", label: "GitHub" },
  { value: "gitlab", label: "GitLab" },
  { value: "bitbucket", label: "Bitbucket" },
  { value: "jira", label: "Jira" },
  { value: "confluence", label: "Confluence" },

  // Mobile Development
  { value: "react-native", label: "React Native" },
  { value: "flutter", label: "Flutter" },
  { value: "ionic", label: "Ionic" },
  { value: "xamarin", label: "Xamarin" },
  { value: "android", label: "Android Development" },
  { value: "ios", label: "iOS Development" },

  // Data Science & ML
  { value: "pandas", label: "Pandas" },
  { value: "numpy", label: "NumPy" },
  { value: "scikit-learn", label: "Scikit-learn" },
  { value: "tensorflow", label: "TensorFlow" },
  { value: "pytorch", label: "PyTorch" },
  { value: "jupyter", label: "Jupyter" },
  { value: "r", label: "R" },
  { value: "tableau", label: "Tableau" },
  { value: "powerbi", label: "Power BI" },

  // Testing
  { value: "jest", label: "Jest" },
  { value: "automation_testing", label: "Automation Testing" },
  { value: "manual_testing", label: "Manual Testing" },
  { value: "database_testing", label: "Database Testing" },
  { value: "api_testing", label: "API Testing" },
  { value: "cypress", label: "Cypress" },
  { value: "selenium", label: "Selenium" },
  { value: "pytest", label: "PyTest" },
  { value: "junit", label: "JUnit" },
  { value: "mocha", label: "Mocha" },

  // Other Tools & Technologies
  { value: "graphql", label: "GraphQL" },
  { value: "rest-api", label: "REST API" },
  { value: "websockets", label: "WebSockets" },
  { value: "microservices", label: "Microservices" },
  { value: "agile", label: "Agile/Scrum" },
  { value: "linux", label: "Linux" },
  { value: "bash", label: "Bash/Shell Scripting" },
  { value: "vim", label: "Vim" },
  { value: "vscode", label: "VS Code" },
  { value: "canva", label: "Canva" },
  { value: "adobe_xd", label: "Adobe XD" },
  { value: "figma", label: "Figma" },
  { value: "photoshop", label: "Photoshop" },
  { value: "Other", label: "Other" }
];

export const interviewerOptions = [
  { value: "", label: "Select Interviewer", disabled: true, hidden: true },
  { value: "martina_nikolaus", label: "Martina Nikolaus" },
  { value: "jermain_beatty", label: "Jermain Beatty" },
  { value: "bertram_roberts", label: "Mr. Bertram Roberts Sr." },
  { value: "meggie_streich", label: "Meggie Streich" },
  { value: "johnson_veum", label: "Dr. Johnson Veum Sr." },
  { value: "giles_conn", label: "Giles Conn" },
];

export const interviewTypeOptions = [
  { value: "", label: "Select Interview Type", disabled: true, hidden: true },
  { value: "in_person", label: "In Person" },
  { value: "video", label: "Video" },
  { value: "phone", label: "Phone" },
];

export const candidateOptions = [
  { value: "", label: "Select Candidate", disabled: true, hidden: true },
  { value: "keanu_bailey_sr", label: "Keanu Bailey Sr." },
  { value: "colten_mcglynn", label: "Colten McGlynn" },
  { value: "demario_greenholt", label: "Demario Greenholt" },
  { value: "sylvester_kessler", label: "Sylvester Kessler" },
  { value: "chelsey_abernathy", label: "Chelsey Abernathy" },
];
export const experienceRangeOptions = [
  { value: "0-1", label: "0 – 1 Year" },
  { value: "1-3", label: "1 – 3 Years" },
  { value: "3-5", label: "3 – 5 Years" },
  { value: "5-8", label: "5 – 8 Years" },
  { value: "8-12", label: "8 – 12 Years" },
  { value: "12+", label: "12+ Years " },
];

export const totalExperienceOptions = [
  { value: "", label: "Select Experience", disabled: true, hidden: true },
  { value: "0-1", label: "0-1 Years" },
  { value: "1-2", label: "1-2 Years" },
  { value: "2-3", label: "2-3 Years" },
  { value: "3-5", label: "3-5 Years" },
  { value: "5-7", label: "5-7 Years" },
  { value: "7-10", label: "7-10 Years" },
  { value: "10+", label: "10+ Years" },
];

export const noticePeriodOptions = [
  // { value: "", label: "Select Notice Period", disabled: true, hidden: true },
  { value: "immediate", label: "Immediate" },
  { value: "15_days", label: "15 Days" },
  { value: "30_days", label: "30 Days" },
  { value: "60_days", label: "60 Days" },
  { value: "90_days", label: "90 Days" },
  { value: "more_than_90", label: "More than 90 Days" },
];

export const applicationSourceOptions = [
  // { value: "", label: "Select Application Source", disabled: true, hidden: true },
  { value: "linkedin", label: "Linkedin" },
  { value: "naukri", label: "Naukri" },
  { value: "indeed", label: "Indeed" },
  { value: "referral", label: "Referral" },
  { value: "hirest", label: "Hirest" },
  { value: "others", label: "Others" },
];

export const interviewAvailabilityOptions = [
  { value: "09_00_10_00", label: "9:00 AM - 10:00 AM" },
  { value: "10_00_11_00", label: "10:00 AM - 11:00 AM" },
  { value: "11_00_12_00", label: "11:00 AM - 12:00 PM" },
  { value: "12_00_13_00", label: "12:00 PM - 1:00 PM" },
  { value: "13_00_14_00", label: "1:00 PM - 2:00 PM" },
  { value: "14_00_15_00", label: "2:00 PM - 3:00 PM" },
  { value: "15_00_16_00", label: "3:00 PM - 4:00 PM" },
  { value: "16_00_17_00", label: "4:00 PM - 5:00 PM" },
  { value: "17_00_18_00", label: "5:00 PM - 6:00 PM" },
  { value: "18_00_19_00", label: "6:00 PM - 7:00 PM" },
  { value: "19_00_20_00", label: "7:00 PM - 8:00 PM" },
];

export const totalExperienceRangeOptions = [
  // { value: "", label: "Select Experience Range", disabled: true, hidden: true },
  { value: "0-1", label: "0 - 1 years" },
  { value: "1-3", label: "1 - 3 years" },
  { value: "3-5", label: "3 - 5 years" },
  { value: "5-10", label: "5 - 10 years" },
  { value: "10+", label: "10+ years" },
];

export const reminderOptions = [
  { value: "", label: "Select Reminder Type", disabled: true, hidden: true },
  { value: "days", label: "Day(s)" },
  { value: "hours", label: "Hour(s)" },
  { value: "minutes", label: "Minute(s)" },
];

export const roleTypeOptions = [
  //  { value: "", label: "Select Role Type", disabled: true, hidden: true },
  { value: "guest", label: "Guest" },
  { value: "employee", label: "Employee" },
];

export const roleTypeOptionsHiringManager = [
  //  { value: "", label: "Select Role Type", disabled: true, hidden: true },
  { value: "recruiter", label: "Recruiter" },
  { value: "employee", label: "Employee" },
];

export const indianStatesOptions = [
  {
    value: "",
    label: "Select State or union territory",
    disabled: true,
    hidden: true,
  },
  // States
  { value: "Andhra Pradesh", label: "Andhra Pradesh" },
  { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
  { value: "Assam", label: "Assam" },
  { value: "Bihar", label: "Bihar" },
  { value: "Chhattisgarh", label: "Chhattisgarh" },
  { value: "Goa", label: "Goa" },
  { value: "Gujarat", label: "Gujarat" },
  { value: "Haryana", label: "Haryana" },
  { value: "Himachal Pradesh", label: "Himachal Pradesh" },
  { value: "Jharkhand", label: "Jharkhand" },
  { value: "Karnataka", label: "Karnataka" },
  { value: "Kerala", label: "Kerala" },
  { value: "Madhya Pradesh", label: "Madhya Pradesh" },
  { value: "Maharashtra", label: "Maharashtra" },
  { value: "Manipur", label: "Manipur" },
  { value: "Meghalaya", label: "Meghalaya" },
  { value: "Mizoram", label: "Mizoram" },
  { value: "Nagaland", label: "Nagaland" },
  { value: "Odisha", label: "Odisha" },
  { value: "Punjab", label: "Punjab" },
  { value: "Rajasthan", label: "Rajasthan" },
  { value: "Sikkim", label: "Sikkim" },
  { value: "Tamil Nadu", label: "Tamil Nadu" },
  { value: "Telangana", label: "Telangana" },
  { value: "Tripura", label: "Tripura" },
  { value: "Uttar Pradesh", label: "Uttar Pradesh" },
  { value: "Uttarakhand", label: "Uttarakhand" },
  { value: "West Bengal", label: "West Bengal" },
  // { value: "UP", label: "UP" },

  // Union Territories
  {
    value: "Andaman and Nicobar Islands",
    label: "Andaman and Nicobar Islands",
  },
  { value: "Chandigarh", label: "Chandigarh" },
  {
    value: "Dadra and Nagar Haveli and Daman and Diu",
    label: "Dadra and Nagar Haveli and Daman and Diu",
  },
  { value: "Delhi", label: "Delhi" },
  { value: "Jammu and Kashmir", label: "Jammu and Kashmir" },
  { value: "Ladakh", label: "Ladakh" },
  { value: "Lakshadweep", label: "Lakshadweep" },
  { value: "Puducherry", label: "Puducherry" },
];

// constants/jobTitleOptions.js (or wherever you keep your constants)
export const jobTitleOptions = [
  // { value: "", label: "Select Job Title", disabled: true, hidden: true },
  { value: "software-engineer", label: "Software Engineer" },
  { value: "senior-software-engineer", label: "Senior Software Engineer" },
  { value: "frontend-developer", label: "Frontend Developer" },
  { value: "backend-developer", label: "Backend Developer" },
  { value: "fullstack-developer", label: "Full Stack Developer" },
  { value: "devops-engineer", label: "DevOps Engineer" },
  { value: "data-scientist", label: "Data Scientist" },
  { value: "data-analyst", label: "Data Analyst" },
  { value: "product-manager", label: "Product Manager" },
  { value: "project-manager", label: "Project Manager" },
  { value: "ui-ux-designer", label: "UI/UX Designer" },
  { value: "graphic-designer", label: "Graphic Designer" },
  { value: "marketing-manager", label: "Marketing Manager" },
  { value: "sales-representative", label: "Sales Representative" },
  { value: "business-analyst", label: "Business Analyst" },
  { value: "hr-manager", label: "HR Manager" },
  { value: "hiring-manager", label: "Hiring Manager" },
  { value: "operations-manager", label: "Operations Manager" },
  { value: "finance-manager", label: "Finance Manager" },
  { value: "customer-support", label: "Customer Support Specialist" },
  { value: "qa-engineer", label: "QA Engineer" },
  { value: "system-administrator", label: "System Administrator" },
  { value: "technical-writer", label: "Technical Writer" },
  { value: "consultant", label: "Consultant" },
  { value: "intern", label: "Intern" },
];

export const interviewRoundOptions = [
  { value: "Round 1", label: "Round 1" },
  { value: "Round 2", label: "Round 2" },
  { value: "Round 3", label: "Round 3" },
  { value: "HR Round", label: "HR Round" },
  { value: "Managerial Round", label: "Managerial Round" },
  { value: "Technical Round", label: "Technical Round" },
  { value: "Final Round", label: "Final Round" },
];

export const CANDIDATE_STATUS = {
  NEW: "new",
  IN_REVIEW: "inreview",
  AVAILABLE: "available",
  ENGAGED: "engaged",
  OFFERED: "offered",
  HIRED: "hired",
  REJECTED: "rejected",
};

export const candidateStageOptions = [
  { label: "New", value: CANDIDATE_STATUS.NEW },
  { label: "In Review", value: CANDIDATE_STATUS.IN_REVIEW },
  { label: "Available", value: CANDIDATE_STATUS.AVAILABLE },
  { label: "Engaged", value: CANDIDATE_STATUS.ENGAGED },
  { label: "Offered", value: CANDIDATE_STATUS.OFFERED },
  { label: "Hired", value: CANDIDATE_STATUS.HIRED },
  { label: "Rejected", value: CANDIDATE_STATUS.REJECTED },
];

export const qualificationOptions = [
  { value: "phd", label: "Ph.D / Doctorate" },
  { value: "post_graduate", label: "Postgraduate (M.Tech/ MCA / MBA / M.Sc / MA / MDES)" },
  { value: "graduate", label: "Graduate (B.Tech / B.Sc / B.Com / BA /BDES)" },
  { value: "diploma", label: "Diploma / Polytechnic" },
  { value: "hsc", label: "Higher Secondary (12th)" },
  { value: "ssc", label: "Secondary School (10th)" },
  { value: "certification", label: "Professional Certification" },
  { value: "others", label: "Others" },
];

export const experienceOptions = [
  { value: 0, label: "Fresher" },
  { value: 1, label: "1 Year" },
  { value: 2, label: "2 Years" },
  { value: 3, label: "3 Years" },
  { value: 4, label: "4 Years" },
  { value: 5, label: "5 Years" },
  { value: 6, label: "6 Years" },
  { value: 7, label: "7 Years" },
  { value: 8, label: "8 Years" },
  { value: 9, label: "9 Years" },
  { value: 10, label: "10 Years" },
  { value: 11, label: "11 Years" },
  { value: 12, label: "12 Years" },
  { value: 13, label: "13 Years" },
  { value: 14, label: "14 Years" },
  { value: 15, label: "15+ Years" },
];

export const jobOpeningIndustryOptions = [
  { value: "information_technology", label: "Information Technology" },
  { value: "finance", label: "Finance & Banking" },
  { value: "healthcare", label: "Healthcare & Pharmaceuticals" },
  { value: "education", label: "Education & Training" },
  { value: "manufacturing", label: "Manufacturing" },
  { value: "retail", label: "Retail & E-commerce" },
  { value: "telecommunications", label: "Telecommunications" },
  { value: "construction", label: "Construction & Infrastructure" },
  { value: "hospitality", label: "Hospitality & Tourism" },
  { value: "media", label: "Media & Entertainment" },
  { value: "automotive", label: "Automotive" },
  { value: "logistics", label: "Logistics & Supply Chain" },
  { value: "agriculture", label: "Agriculture & Farming" },
  { value: "legal", label: "Legal Services" },
  { value: "energy", label: "Energy & Utilities" },
  { value: "real_estate", label: "Real Estate" },
  { value: "aerospace", label: "Aerospace & Defense" },
  { value: "public_sector", label: "Government & Public Sector" },
  { value: "non_profit", label: "Non-Profit & NGOs" },
  { value: "fashion", label: "Fashion & Apparel" },
];

export const interviewModeOptions = [
  { value: "in_person", label: "In-Person" },
  { value: "virtual", label: "Virtual" },
  { value: "telephonic", label: "Telephonic" },
];

export const ratingOptions = [
  { value: 0, label: "0 - Very Poor" },
  { value: 1, label: "1 - Poor" },
  { value: 2, label: "2 - Below Average" },
  { value: 3, label: "3 - Fair" },
  { value: 4, label: "4 - Average" },
  { value: 5, label: "5 - Good" },
]
